import React from 'react';
import { Box } from '@mui/material';
import Header from './Header';
import { SEOHead } from '../common';
import { useTranslation } from 'react-i18next';

const PageHeader = ({
  // SEO props
  streamingSummary,
  selectedHistory,
  
  // Header props
  inputUrl,
  setInputUrl,
  inputTitle,
  loading,
  error,
  isLoggedIn,
  userEmail,
  user,
  handleLogout,
  handleAnalyze,
  drawerOpen,
  setDrawerOpen,
  setLoginDialogOpen,
  fetchYoutubeTitle
}) => {
  const { t } = useTranslation();

  return (
    <>
      <SEOHead
        title={t('seo.titleWithAnalysis')}
        description={streamingSummary || selectedHistory?.summary}
      />
      <Box sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        zIndex: 1200
      }}>
        <Header
          url={inputUrl}
          setUrl={setInputUrl}
          videoTitle={inputTitle}
          loading={loading}
          error={error}
          isLoggedIn={isLoggedIn}
          userEmail={userEmail}
          user={user}
          handleLogout={handleLogout}
          handleAnalyze={handleAnalyze}
          drawerOpen={drawerOpen}
          setDrawerOpen={setDrawerOpen}
          setLoginDialogOpen={setLoginDialogOpen}
          fetchYoutubeTitle={fetchYoutubeTitle}
          hideLoginButton={true}
        />
      </Box>
    </>
  );
};

export default PageHeader; 